import apiConfig from "@/config/apiConfig";
const financeApi = apiConfig.financeApi;


//高企查询
export const basicsSS = {
    pageList: financeApi + "/basicsSS/pageList", // 分页管理(get)
}



